import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { BaseFooter } from "./BaseFooter";
import { EditModeButton } from "./EditModeButton";
import { AIPanelToggleButton } from "./icon-buttons/AIPanelToggleButton";

import { VerticalDivider } from "mds/components/VerticalDivider";
import { useHomeRoleCapabilities } from "store/capability-hooks";

export const HomeFooter: FC = () => {
  const { canAuthorSection, canAuthorOrg } = useHomeRoleCapabilities();

  return (
    <BaseFooter>
      <div
        className={twMerge(
          "flex h-full w-full items-center",
          canAuthorSection ? "justify-around" : "justify-end",
        )}
      >
        <div className="flex h-full items-center gap-2">
          {canAuthorSection && (
            <>
              <EditModeButton isDisabled={!canAuthorOrg} />
              <VerticalDivider className="h-6 border-black-tint-90" />
            </>
          )}
          <AIPanelToggleButton />
        </div>
      </div>
    </BaseFooter>
  );
};
